/* esm.sh - @floating-ui/utils@0.2.11 */
export * from "/*@floating-ui/utils@0.2.11/esnext/utils.mjs";
